<template>
    <div class="financeSupport">
        <div class="header__title header__title--center">
            <h2>{{ dataFinanceSupport.title }}</h2>
        </div>

        <v-layout wrap class="financeSupport__wrap">
            <v-flex
                v-for="(item, index) in dataFinanceSupport.support"
                :key="index"
                class="financeSupport__support"
                xs12
                md4
            >
                <DynamicImage
                    :image-name="item.image"
                    class="icon__support"
                    :alt="item.title"
                />

                <p class="h4">{{ item.title }}</p>

                <p>{{ item.text }}</p>

                <ul class="financeSupport__list">
                    <li v-for="(listItem, key) in item.list" :key="key">
                        <a
                            :href="listItem.link"
                            class="financeSupport__listItem"
                        >
                            <span>{{ listItem.text }}</span>
                            <SVGIcon
                                icon-name="chevron-right"
                                class="icon__chevron"
                            />
                        </a>
                    </li>
                </ul>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'
import DynamicImage from '@/components/atoms/image/dynamicImage.vue'

export default {
    name: 'FinanceSupport',

    components: {
        SVGIcon,
        DynamicImage,
    },

    data: () => ({
        dataFinanceSupport: {
            title: 'Mehr Informationen zur Pflegekasse',
            support: [
                {
                    title: 'Leistungen der Pflegekasse',
                    text:
                        'Ab Pflegegrad 1 haben Sie Ansprüche auf Leistungen aus Ihrer Pflegeversicherung.',
                    image: 'graphics/pig-coins.png',
                    list: [
                        {
                            text: 'Entlastungsbetrag (ab PG 1)',
                            link:
                                '/senioren-ratgeber/den-entlastungsbetrag-gekonnt-nutzen/',
                        },
                        {
                            text: 'Verhinderungspflege (ab PG 2)',
                            link: '/senioren-ratgeber/verhinderungspflege/',
                        },
                        {
                            text: 'Pflegegeld',
                            link: '/senioren-ratgeber/pflegegeld/',
                        },
                        {
                            text: 'Hilfe bei der Antragsstellung',
                            link:
                                '/senioren-ratgeber/leistungen-der-pflegeversicherung/',
                        },
                    ],
                },
                {
                    title: 'Finanzierung von Pflegeleistungen',
                    text:
                        'Je nach Pflegeform gibt es verschiedene Förderleistungen, die Sie nutzen können.',
                    image: 'graphics/pig-insert-coin.png',
                    list: [
                        {
                            text: 'Erstattung von Pflegekosten',
                            link:
                                '/senioren-ratgeber/finanzierung-und-erstattung-von-pflegekosten/',
                        },
                        {
                            text: 'Pflege von der Steuer absetzen ',
                            link:
                                '/senioren-ratgeber/leistungen-von-der-steuer-absetzen/',
                        },
                    ],
                },
                {
                    title: 'Haben Sie einen Pflegegrad?',
                    text:
                        'Es gibt 5 Pflegegrade. Je nach Pflegegrad, ergeben sich unterschiedliche Pflegeleistungen.',
                    image: 'graphics/pig-search.png',
                    list: [
                        {
                            text: 'Übersicht Pflegegrade',
                            link:
                                '/senioren-ratgeber/pflegebeduerftig-was-nun/',
                        },
                        {
                            text: 'Pflegegrad beantragen',
                            link: '/senioren-ratgeber/pflegegrad-beantragen/',
                        },
                    ],
                },
            ],
        },
    }),
}
</script>

<style lang="stylus">
.financeSupport {

    &__wrap {
        @media $display-breakpoints.md-and-up {
            margin-left: -($cs-spaces.double);
            margin-right: -($cs-spaces.double);
        }
    }


    &__support {
        padding: 0 0 $cs-spaces.quadruple;

        @media $display-breakpoints.md-and-up {
            border-right: $cs-slate-200 1px solid;
            padding: 0 $cs-spaces.double;
        }

        &:last-child {
            border: 0;
            padding: 0;

            @media $display-breakpoints.md-and-up {
                padding: 0 $cs-spaces.double;
            }
        }
    }

    .h4 {
        margin: 0 0 $cs-spaces.half;
    }

    &__list {
        padding: $cs-spaces.half 0;
    }

    &__listItem {
        align-items: center;
        background: $cs-slate-050;
        border-radius: $cs-border-radius;
        color: $cs-slate-400;
        display: flex;
        font-size: 18px;
        font-weight: 500;
        justify-content: space-between;
        margin: $cs-spaces.half 0;
        padding: $cs-spaces.half $cs-space;
        text-decoration: none;
        transition: all 200ms ease-in-out;

        &:hover {
            background: $cs-slate-100;
        }

        &:hover .icon__chevron {
            transform: translateX($cs-spaces.half);
        }
    }

    .icon__support {
        display: block;
        height: auto;
        margin: 0 auto $cs-spaces.double;
        width: 130px;

        @media $display-breakpoints.md-and-up {
            margin: 0 auto $cs-spaces.triple;
        }
    }

    .icon__chevron {
        flex: 0 0 auto;
        height: 20px;
        margin: 0 0 0 $cs-spaces.half;
        transition: all 300ms ease-in-out;
        width: 20px;
    }
}
</style>
